export default "__VITE_ASSET__c6d042fa__"